import {useTheme} from "../../../contexts/theme";
import Box from "@mui/material/Box";
import StyledCollapse from "../StyledCollapse/StyledCollapse";
import Grid from "@mui/material/Grid";
import {FormControl, FormControlLabel} from "@mui/material";
import StyledCheckBox from "../StyledCheckbox/StyledCheckBox";
import React, {useEffect} from "react";
import TextinputField from "../TextInputField/TextinputField";


interface PreSetsConfigProps {
    onClose?: () => void;
    onOpen?: () => void;
    enablePresets: boolean;
    handleChangeEnablePresets: (event: React.ChangeEvent<HTMLInputElement>) => void;
    namePresets: string;
    handleChangeNamePresets: (name_conf: string) => void;
}

const PreSetConfig = ({onClose,onOpen, handleChangeEnablePresets, enablePresets, namePresets, handleChangeNamePresets}:PreSetsConfigProps) =>{



    const theme = useTheme();

    return (
        <Box display={'flex'} flexDirection={'column'}>
            <Box>

                <StyledCollapse onClose={onClose} onOpen={onOpen} title={'Save Job Preset'}>
                    <Grid container spacing={2} alignItems={'center'}>


                        <Grid item xs={12} md={6} lg={6}>
                            <FormControlLabel
                                sx={{color: theme.palette.white, marginLeft: '0px'}}
                                control={
                                    <StyledCheckBox
                                        height={'20px'}
                                        width={'20px'}
                                        iconSize={'20px'}
                                        checked={enablePresets}
                                        onChange={(e) => handleChangeEnablePresets(e as any) }
                                    />
                                }
                                label={'Save the setting'}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>

                            <FormControl fullWidth={true} sx={{
                                paddingTop: theme.spacing.sm
                            }}>
                                <TextinputField placeholder='Name of Presets' label={'Name of Presets'} type='text' variant={'outlined'}
                                                value={namePresets}
                                                disabled={!enablePresets}
                                                size={'medium'}
                                                onChange={(e) => handleChangeNamePresets(e.target.value) }
                                                name={'name'}
                                                id={"outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.white}
                                                borderColor={theme.palette.white}
                                                borderRadius={theme.border.width.hard}

                                ></TextinputField>
                            </FormControl>


                        </Grid>

                    </Grid>

                </StyledCollapse>


            </Box>
        </Box>

    );
}

export default PreSetConfig